export const winds =
  "https://aviationweather.gov/data/windtemp/?region=mia&fcst=12&level=low";

export const metar =
  "https://aviationweather.gov/data/metar";

export const taf =
  "https://aviationweather.gov/data/taf";

export const afd =
  "https://faa-data-client.vercel.app";

export const mvar =
  "https://www.ngdc.noaa.gov/geomag/calculators/magcalc.shtml";